import { Collapse, Tag } from 'antd';
import { ShieldAlert } from 'lucide-react';
import { Navigate } from 'react-router';
import { EmptyState } from '../../components/EmptyState';
import { PageHeader } from '../../components/PageHeader';
import { RowListSkeleton } from '../../components/RowListSkeleton';
import { useRolesCatalogue } from './use-roles-catalogue';

export function RolesPage() {
  const state = useRolesCatalogue();

  if (state.status === 'forbidden') return <Navigate to="/" replace />;

  return (
    <>
      <PageHeader eyebrow="Admin" title="Roles" description="Every role and the permissions it grants. Editing is seed-only for now." />
      {state.status === 'error' && (
        <EmptyState icon={ShieldAlert} title="Couldn't load roles" description="Something went wrong loading the roles catalogue. Try reloading the page." />
      )}
      {state.status === 'loading' && <RowListSkeleton label="Loading roles" rows={6} />}
      {state.status === 'loaded' && (
        <Collapse
          items={state.roles.map((role) => ({
            key: role.key,
            label: role.name,
            children: (
              <div className="flex flex-wrap gap-1.5">
                {[...role.permissions].sort().map((permission) => (
                  <Tag key={permission} className="font-mono text-xs">
                    {permission}
                  </Tag>
                ))}
              </div>
            ),
          }))}
        />
      )}
    </>
  );
}
